export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/57a43ba76340ea303ae7dc89733370a0.svg";